import { render, staticRenderFns } from "./Verify.vue?vue&type=template&id=bda7aa04&scoped=true"
import script from "./Verify.vue?vue&type=script&lang=js"
export * from "./Verify.vue?vue&type=script&lang=js"
import style0 from "./Verify.vue?vue&type=style&index=0&id=bda7aa04&prod&lang=scss"
import style1 from "./Verify.vue?vue&type=style&index=1&id=bda7aa04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda7aa04",
  null
  
)

export default component.exports